export const UNCATEGORIZED_VALUE = ''
export const UNCATEGORIZED_LABEL = 'Uncategorized'
export const MIXED_CATEGORIES_LABEL = 'Mixed categories'
export const SECONDS = 1000;
